import React from 'react';
import { useInView } from 'react-intersection-observer';
import styles from './Contentright.module.css'
import colors from '../constants/colors.json'
import app_store from "../images/app-store.png";
import google_play from "../images/google-play.png";
import styles2 from "./Heroarea.module.css";

export default function AboutUs({title, description,}) {
  
  const { ref, inView } = useInView({
    triggerOnce: true, 
  });
  const updatedDescription = description
    ? description.replace(/rgb\(0,\s*0,\s*0\)/g, "white")
    : "";
  return (
    <div
      id="home-about-section"
      className="row justify-content-center g-0"
      style={{ backgroundColor: colors.primary }}
    >
      <div className="col-12 px-3 px-md-4 px-lg-5">
      <div className="row align-items-center justify-content-center g-0">
                    
                    <div className="col-12">
                      {/* <br /> */}
                      {/* <br /> */}

                      <div className={`${styles.contentrighttext} ${styles.contentWrapper} ${inView ? styles.inView : ''}`}ref={ref} >
                        {/* <h2 style={{color: colors.white , textAlign: 'left'}}>{title}</h2> */}
                        <div
                          style={{ color: colors.white, textAlign: "center" }}
                          dangerouslySetInnerHTML={{
                            __html: updatedDescription,
                          }}
                        />
                      </div>
                    </div>
                   
                  </div>
                </div>
    </div>
  );
}
